export const MAX_FILE_SIZE = 52_428_800; // 50MB
export const MIN_FILE_SIZE = 1_048_576;  // 1MB
export const ALLOWED_EXTENTIONS_FILE = ['pdf'];

export const ERROR_LARGE_SIZE_MESSAGE = 'The file is too large, please upload a file 50Mb max.';
export const ERROR_SMALL_SIZE_MESSAGE = 'The file is too small, please upload a file 1Mb min.';
export const ERROR_ALLOWED_EXTENTION_MESSAGE = 'Please, upload a file in PDF format.';

export const ENGLISH_HANDBOOK_LABEL = "English"
export const SPANISH_HANDBOOK_LABEL = "Spanish"